import * as React from 'react';
import { DividerProps } from '../../Divider';

declare const Divider: React.FunctionComponent<DividerProps>;

export default Divider;
